'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _MorningstarLink = require('./MorningstarLink.css');

var _MorningstarLink2 = _interopRequireDefault(_MorningstarLink);

var _ = require('../');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MorningstarLink = (_dec = (0, _reactCssModules2.default)(_MorningstarLink2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MorningstarLink, _Component);

  function MorningstarLink(props) {
    (0, _classCallCheck3.default)(this, MorningstarLink);
    return (0, _possibleConstructorReturn3.default)(this, (MorningstarLink.__proto__ || (0, _getPrototypeOf2.default)(MorningstarLink)).call(this, props));
  }

  (0, _createClass3.default)(MorningstarLink, [{
    key: 'render',
    value: function render() {
      var url = this.props.url || _config2.default.links.morningstar;
      var morningstarLogo = require('../../../static/images/img-morningstar.png');
      return _react2.default.createElement(
        _.Link,
        { to: url },
        _react2.default.createElement(
          'div',
          { styleName: 'morningstar-link-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'morningstar-link-info' },
            'Find fund performance',
            _react2.default.createElement('br', null),
            'and other financial metrics',
            _react2.default.createElement('br', null),
            this.props.ticker ? 'for ' + this.props.ticker : null,
            ' on ',
            _react2.default.createElement(
              'span',
              { style: { whiteSpace: 'nowrap' } },
              'Morningstar.com',
              _react2.default.createElement(_.LinkIcon, null)
            )
          ),
          _react2.default.createElement('img', { styleName: 'morningstar-link-img', src: morningstarLogo, alt: 'Morningstar' })
        )
      );
    }
  }]);
  return MorningstarLink;
}(_react.Component), _class2.propTypes = {
  url: _react.PropTypes.string,
  ticker: _react.PropTypes.string
}, _temp)) || _class);
exports.default = MorningstarLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MorningstarLink/MorningstarLink.js
// module id = 1280
// module chunks = 0